import { AccountChargesForPeriodMappedData } from '../../../../mappers/accounts/statistic/charges/index';
import { createDataFetchSlice } from '../../../../utils/dataFetch';


export const accountStatisticChargesSlice = createDataFetchSlice<
    AccountChargesForPeriodMappedData
>({ name: 'charges' });
